import { Routes } from '@angular/router'
import { isAuthenticated } from '../../core/auth/guards/auth.guard'

export const chatRoutes: Routes = [
	{
		path: 'chat',
		canActivate: [isAuthenticated],
		loadComponent: () => import('../../layout/main-layout/main-layout'),
		data: {
			role: '',
			title: 'Chat',
			breadcrumb: 'Chat',
			preload: true,
			roles: [''],
		},
		children: [
			{
				path: 'inbox',
				loadComponent: () => import('./chat-inbox/chat-inbox'),
				data: {
					title: 'chat.title',
					breadcrumb: 'chat.inbox',
					icon: 'chat',
					preload: true,
					roles: [''],
				},
			},
			{
				path: 'conversation/:id',
				loadComponent: () => import('./chat-room/chat-room'),
				data: {
					title: 'chat.conversation',
					breadcrumb: 'chat.conversation',
					roles: [''],
				},
			},
			{ path: '', redirectTo: 'inbox', pathMatch: 'full' },
		],
	},
]
